// extracted by mini-css-extract-plugin
export default {"skeleton-chips":"sE6xCj"};